
import React, { useEffect, useRef ,useState} from 'react';
import videojs from 'video.js';
import { DatePicker } from 'antd';
import 'video.js/dist/video-js.css';
import Box from "@mui/material/Box";
import Sidebar from "./Sidebar";
import { ToastContainer} from "react-toastify";
import { get,post } from '../library/Api';
import {SwapOutlined} from '@ant-design/icons';

import {
    XAxis,
    YAxis,
    CartesianGrid,
    LineChart,
    Legend,
    Tooltip,
    Line,
    Label,
    Bar,
    BarChart,Area,
    ComposedChart,
    ResponsiveContainer,

} from "recharts";





const Parkingdata = () => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const progressRef = useRef(null); 
  const [weekday, setWeekday] = useState(["Weekday"]);
  const [selectedDate, setselectedDate] = useState("");
  const [srcUrl, setsrcUrl] = useState("https://d1s4th28aykoif.cloudfront.net/2024-02-01.mp4");
  const [color, setColor] = useState([]);
  const [nerge, setNerge] = useState([null]);
  const arryDatass = [];
  const [myDatas, setmyDatas] = useState([
    {
        "meter": "179073",
        "code": "PD",
        "name": "250 ASSAY ST"
    }
]);

 const onMouseClick = event => {
  setWeekday(event.target.id);
};

const onChangeDate = (date, dateString) => {
    console.log(date,'----------', dateString);
    const videoUrl = "https://d1s4th28aykoif.cloudfront.net/" +dateString +".mp4"
    // const temp = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"  # '2024-03-14'
    const temp = "https://d1s4th28aykoif.cloudfront.net/27_02_2024.mp4";  
    setsrcUrl(temp)
    console.log('videoUrl',temp)
    setselectedDate(dateString)
  };



  useEffect(() => {
        // if(selectedDate){
        //     var dateStr = selectedDate
        // }
        // else {
        // // var user = JSON.parse(localStorage.getItem("MCData"));
        // const currentDate = new Date().toLocaleString("en-US", { timeZone: "America/Chicago" });
        // const formattedDate = new Date(currentDate).toISOString().split('T')[0];
        // console.log(" --- ",formattedDate)
        // var dateStr = "2024-02-17"
        // }
        
        var dateStr = selectedDate
        get(`parkingdata?datetime=${dateStr}`)
            .then(response => {

                console.log("parking api data ==== ",response.data);
                setNerge(response.data);
                // setColor(response.dat);

            });
            
            // hourly_data.data.hourly_avg.option_one.map((item) => {
            //     let name = item[0].name;
            //     // console.log(name);
            //     const meterData = Object.fromEntries(
            //         item?.map(({ avg, meter_id }) => [meter_id, avg]),
            //     );

            //     const weeklyMeterData = { name, ...meterData };
            //     console.log()

            //     arryDatass.push(weeklyMeterData);
            // });
            
            // setNerge(api_data);
    }, []);


  
    useEffect(() => {
        // Initialize Video.js player if it doesn't exist
        if (!playerRef.current) {
          playerRef.current = videojs(videoRef.current, {
            // Video.js options
            controls: true,
            autoplay: true,
            preload: 'auto',
          });
      
          // Add event listener for timeupdate to update the progress bar
          playerRef.current.on('timeupdate', () => {
            if (progressRef.current) {
              const currentTime = playerRef.current.currentTime();
              const duration = playerRef.current.duration();
              const percentage = (currentTime / duration) * 100;
              progressRef.current.style.width = `${percentage}%`;
            }
          });
        }
      
        // Clean up on unmount (conditionally)
        return () => {
          if (playerRef.current && !document.documentElement.contains(videoRef.current)) {
            playerRef.current.dispose();
            playerRef.current = null;
          }
        };
      }, []);



  useEffect(() => {
    if (playerRef.current) {
      // Pause the current video playback (if it's playing)
      playerRef.current.pause();
      // Load the new video specified by srcUrl
      playerRef.current.src({ type: 'video/mp4', src: srcUrl });
      // Check if autoplay is allowed (user interaction occurred)
      const isAutoplayAllowed = document.documentElement.dataset.autoplay === 'true';
      if (isAutoplayAllowed) {
        // Play the new video
        playerRef.current.play();
      } else {
        // Handle autoplay restriction (e.g., show play button and wait for user interaction)
      }
    }
  }, [srcUrl]);




  const handlePlayButtonClick = () => {
    if (playerRef.current) {
      if (playerRef.current.paused()) {
        playerRef.current.play();
      } else {
        playerRef.current.pause();
      }
    }
  };






  
  return (
    <React.Fragment>
<ToastContainer />
{/* <Navbar name="Dashboard" /> */}
<Box sx={{ display: "flex" }}>
  <Sidebar />
  <Box component="main" sx={{ flexGrow: 1, p: 3 }}>

   

    <div className="App">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h3 className="heading-style">Parking</h3>
        <div className="d-flex align-items-center">
        <div className="" style={{    display: 'block',
    width: '180px',
    height: '40px',}}>
      <select name="All meters" id="selector" className="selection-video" onChange={onMouseClick} >
                    <option value="" disabled selected >-- select day --</option>
                  <option value="Sunday" >Sunday</option>
                  <option value="Monday" >Monday </option>
                  <option value="Tuesday" >Tuesday</option>
                  <option value="Wednesday">Wednesday</option>
                  <option value="Thursday" >Thursday </option>
                  <option value="Friday">Friday</option>
                  <option value="Saturday">Saturday</option>
                </select>
                </div>
                <div className=" ms-3" style={{    display: 'block',
    width: '180px',
    height: '40px',}}>
      <DatePicker className="selection-video" onChange={onChangeDate}  separator={<SwapOutlined />} /> 
      </div>
      </div>
      </div>

     {/*  */}
        <div class="row">
          <div className="col-md-12 bg-white py-5">
           
            <div className="d-flex justify-content-center flex-column align-items-center">
            <div className="w-100 text-center my-3">
            </div>
              <div class="videoplay">

                <video ref={videoRef} className="video-js" >
                  <source src={srcUrl} type="video/mp4" />
                </video>

                </div>
              </div>
              <div className="col-md-12">
                  
    {/* <div style={{ maxWidth: "100%", margin: "0 auto", minHeight: "350px" }} className="legend-wrapper position-relative scroll-show" > */}
   
    <h3 className="p-5 text-center mt-4">Overall Parking </h3>
   <div className="col-md-12">

  
   <div style={{ maxWidth: "90%", margin: "0 auto", minHeight: "350px" }} className="legend-wrapper position-relative scroll-show" >

 <ResponsiveContainer><>
<LineChart
    data={nerge}
    width={1450}
    height={350}
    margin={{
        top: 5,
        right: 10,
        left: 20,
        bottom: 1,
    }}
    className=""
>

    <XAxis dataKey="time" interval={5} angle={0} dx={20} dy={0}/>
    <YAxis />

    <div className="px-2 d-flex flex-wrap justify-content-center align-items-center mt-5 " style={{    width: '90%', margin: 'auto'}}>
        {/* {myDatas?.map((item, index) => (
            <>
                <div className="d-flex me-1 mb-2">
                    <div style={{ width: 10, height: 10, backgroundColor: color[index], marginRight: 6 }}></div>
                    <span className="meter-content"><font color={color[index]}>{item.meter}-{item.name}[{item.code}]</font></span>
                    </div>
            </>
        ))} */}
    </div> 
    {myDatas?.map((item, index) => (

        <Line type="monotone"
            dataKey={"count"}
            isAnimationActive={false}
            name={"vehicles"}
            // fill={color[index]}
            // stroke={color[index]}
            strokeWidth={2}
        >
        </Line>
    )
    )}
    <CartesianGrid stroke="lightGrey" />
    <Tooltip />
</LineChart>

<div className='labelYAxis2'>Floors </div>
<div className="px-2 d-flex flex-wrap justify-content-center align-items-center mt-5 " style={{width:'90%', margin: 'auto'}}>
    {myDatas?.map((item, index) => (
        <>
            <div className="d-flex me-1 mb-2">
                <div style={{ width: '10px', height: '10px', marginRight: '6px', backgroundColor: 'rgb(255, 0, 0)' }}></div>
                <span className="meter-contents"><font color={color[index]}>Time</font></span></div>
        </>
    ))}
</div>
</>
</ResponsiveContainer>
</div>
</div>
{/* </div> */}
              </div>
          </div>
        </div>
    
    </div>
    <div></div>
    </Box>
  </Box>
</React.Fragment>
  );
};

export default Parkingdata;
